import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { uploadInjectionKey as y } from "./interface.js";
import F from "./UploadFile.js";
import L from "./UploadTrigger.js";
import { throwError as C } from "../../_utils/naive/warn.js";
import N from "../../image/src/ImageGroup.js";
import T from "../../_internal/fade-in-expand-transition/src/FadeInExpandTransition.js";
import { defineComponent as U, inject as h, computed as b, h as l } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const O = U({
  name: "UploadFileList",
  setup(I, {
    slots: f
  }) {
    const o = h(y, null);
    o || C("upload-file-list", "`n-upload-file-list` must be placed inside `n-upload`.");
    const {
      abstractRef: p,
      mergedClsPrefixRef: r,
      listTypeRef: s,
      mergedFileListRef: n,
      fileListClassRef: m,
      fileListStyleRef: c,
      cssVarsRef: u,
      themeClassRef: a,
      maxReachedRef: v,
      showTriggerRef: g,
      imageGroupPropsRef: R
    } = o, t = b(() => s.value === "image-card"), d = () => n.value.map((e, i) => l(F, {
      clsPrefix: r.value,
      key: e.id,
      file: e,
      index: i,
      listType: s.value
    })), x = () => t.value ? l(N, Object.assign({}, R.value), {
      default: d
    }) : l(T, {
      group: !0
    }, {
      default: d
    });
    return () => {
      const {
        value: e
      } = r, {
        value: i
      } = p;
      return l("div", {
        class: [`${e}-upload-file-list`, t.value && `${e}-upload-file-list--grid`, i ? a == null ? void 0 : a.value : void 0, m.value],
        style: [i && u ? u.value : "", c.value]
      }, x(), g.value && !v.value && t.value && l(L, null, f));
    };
  }
});
export {
  O as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/UploadFileList.js
// module id = 1766
// module chunks = 67